<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: KinshipCalculator                                     |
| Section: components                                              |
| Purpose: Call-to-action card for launching kinship calculations. |
+------------------------------------------------------------------+
-->
<template>
    <!-- <section class="KinshipCalculator_container"> -->
    <div class="KinshipCalculator_wrapper wrapper">
        <h2 v-if="currentPersonName">{{ $t('home.kinship.withPerson') }}<br><span>{{ currentPersonName }}</span></h2>
        <h2 v-else>{{ $t('home.kinship.title') }}</h2>
        <BtnPrimary :label="$t('home.kinship.cta')" @click="goToRelationship" />
    </div>
    <!-- </section> -->
</template>

<script>
import BtnPrimary from '@/atoms/BtnPrimary.vue';

export default {
    name: 'KinshipCalculator',
    components: {
        BtnPrimary
    },
    props: {
        personID: {
            type: String,
            required: false,
            default: ''
        },
        person: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    computed: {
        currentPersonName() {
            const firstName = this.person?.firstname || '';
            const lastName = this.person?.lastname || '';
            return `${firstName} ${lastName}`.trim();
        }
    },
    methods: {
        goToRelationship() {
            const firstPersonId = 'I43';

            if (this.personID) {
                this.$router.push({
                    name: 'RelationshipTree',
                    params: {
                        personID1: firstPersonId,
                        personID2: this.personID,
                    },
                    query: {
                        source: 'person',
                        personId: this.personID,
                    },
                });
                return;
            }

            this.$router.push({
                name: 'RelationshipTree',
                query: {
                    source: 'home',
                },
            });
        }
    }
}
</script>

<style scoped>
/* .KinshipCalculator_container {
    background-color: var(--brand-bg-1);
} */

.KinshipCalculator_wrapper {
    background-color: var(--brand-bg-1);
    display: flex;
    padding: 96px;
    /* justify-content: space-between; */
    gap: 32px;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    /* margin-bottom: 144px; */
    border-radius: var(--border-radius-xl);
    max-width: 1280px;
    box-shadow: var(--shadow-card-sm);
}

h2 {
    text-align: center;
}

span {
    color: var(--brand-color-1);
}

@media (max-width: 860px) {
    .KinshipCalculator_wrapper {
        padding: 24px;
        width: calc(100% - 40px);
        gap: 16px;
    }
}
</style>